import { RootState } from '../store';

export const selectComments = (state: RootState) => state.dashboard.comments;
export const selectBrandVoiceGraph = (state: RootState) => state.dashboard.brandVoiceGraph;
export const selectFollowersGraph = (state: RootState) => state.dashboard.followersGraph;
export const selectWeeklyStats = (state: RootState) => state.dashboard.weeklyStats;
export const selectDashboardLoading = (state: RootState) => state.dashboard.loading;
export const selectDashboardError = (state: RootState) => state.dashboard.error;
